import { Strategy } from './../../models/exchange/strategy.model';
import { StocksExchangeInvestment } from './../../models/exchange/stocks-exchange-investment.model';
import { Injectable } from "@angular/core";
import { BackendRegistationStatus } from "../../enum/backend-registration-status.enum";
import { RegistrationStatus } from "../../enum/registration-status.enum";
import { Order } from '../../models/exchange/order.model';
import { OrderType } from '../../enum/orders/order-type.enum';
import { CustodyClientOrder } from '../../models/custody/custody-client-order.model';
import { CustodyStructuredProduct } from '../../models/custody/custody-structured-product.model';

/** Serviço para realizar parse entre informações que vem do backend em formato distindo das necessárias no front */
@Injectable()
export class BackendToFrontendParserService{

    /**
     * Realiza o parse de um status de cadastro entre um valor vindo do backend para um valor usado no front.
     * @param status status a ser parseado
     */
    public parseRegistrationStatus(status: BackendRegistationStatus): RegistrationStatus {

        switch(status){
            case BackendRegistationStatus.None:
                return RegistrationStatus.LoginWithoutAccount;

            case BackendRegistationStatus.Filling:
                return RegistrationStatus.CreatingAccount;

            case BackendRegistationStatus.AwaitingAutomaticVerificationResponse:
            case BackendRegistationStatus.AwaitingAutomaticVerification:
            case BackendRegistationStatus.AwaitingManualVerification:
            case BackendRegistationStatus.AwaitingManualVerificationComplice:
            case BackendRegistationStatus.AwaitingSinacorIntegration:
            case BackendRegistationStatus.AwaitingManualRestrictiveSantanderListVerification:
            case BackendRegistationStatus.AwaitingSendSanctionList:
            case BackendRegistationStatus.AwaitingResponseSanctionList:
            case BackendRegistationStatus.AwaitingManualSanctionListVerification:
                return RegistrationStatus.CreatingAccountAllDataSent;

            case BackendRegistationStatus.AwaitingCETIPIntegrationResponse:
            case BackendRegistationStatus.AwaitingCETIPIntegration:
            case BackendRegistationStatus.AwaitingB3IntegrationResponse:
            case BackendRegistationStatus.AwaitingB3Integration:
            case BackendRegistationStatus.AwaitingTDIntegrationResponse:
            case BackendRegistationStatus.AwaitingTDIntegration:
            case BackendRegistationStatus.InternalIssues:
                return RegistrationStatus.RegisteredUser;

            case BackendRegistationStatus.Canceled:
                return RegistrationStatus.LoginWithoutAccount;

            case BackendRegistationStatus.ExternalIssues:
                return RegistrationStatus.ExternalIssues;

            case BackendRegistationStatus.Ok:
                return RegistrationStatus.ActiveAccount;

            default:
                return RegistrationStatus.CreatingAccount;
        }
    }

    /** Realiza o parse entre um objeto de investimento do exchange retornado pela rota myInvestments para uma estratégia
        @param investment investimento a ser usado
    */
    public parseInvestmentToStrategy(investment: StocksExchangeInvestment): Strategy{

        let strategy = new Strategy();
        //dados da estratégia
        strategy.strategyID = investment.id;
        strategy.isDayTrade = investment.isDayTrade;
        strategy.status = investment.status;
        strategy.symbol = investment.symbol;
        strategy.updatedAt = investment.updatedAt;
        strategy.originType = investment.originType;

        investment.legs.forEach(leg => {
            let order = new Order();
            order.avaragePriceExecuted = leg.averagePriceExecuted;
            order.status = leg.status;
            order.internalOrderType = leg.type;
            order.orderQty = leg.orderQuantity;
            order.side = leg.side;
            order.price = leg.price || leg.averagePriceExecuted;
            order.priceTrigger = leg.priceTrigger;
            strategy.legs.push(order);
        });

        return strategy;
    }
    /** Realiza o parse entre um objeto de investimento do exchange retornado pela rota myInvestments para uma ordem
        @param investment investimento a ser usado
    */
    public parseInvestmentToOrder(investment: StocksExchangeInvestment): Order{
        let order = new Order();
        order.avaragePriceExecuted = investment.averagePriceExecuted;
        order.clOrderID = investment.id;
        order.cumQty = investment.executedAmount;
        order.id = investment.id;
        order.internalOrderType = OrderType.Input;
        order.internalOrderTypeDescription = 'Input';
        order.isDayTrade = investment.isDayTrade;
        order.isStrategy = false;
        order.leavesQty = investment.leavesAmount;
        order.orderQty = investment.executedAmount || investment.orderQuantity;
        order.price = investment.price;
        order.priceType = investment.priceType;
        order.side = investment.side;
        order.status = investment.status;
        order.symbol = investment.symbol;
        order.updatedAt = investment.updatedAt;

        return order;
    }

    /** Realiza o parse entre um objeto de investimento do exchange retornado pela rota myInvestments para uma custódia
        @param investment investimento a ser usado
    */
    public parseInvestmentToCustory(investment: StocksExchangeInvestment): CustodyClientOrder{
        let custody = new CustodyClientOrder(
            investment.symbol,
            investment.executedAmount,
            investment.id,
            investment.isDayTrade,
            investment.averagePrice,
            investment.ordersAmountInvested,
        );

        custody.side = investment.side;

        return custody;
    }

    /** Realiza o parse entre um objeto de investimento retornado pela rota myInvestments para uma custódia de operações estruturadas
        @param investment investimento a ser usado
    */
    public parseInvestmentToStructuredCustody(investment: StocksExchangeInvestment): CustodyStructuredProduct{
        let custody = new CustodyStructuredProduct(
            investment.symbol,
            investment.ordersAmountInvested,
            investment.orderQuantity,
            investment.maturityDate,
            investment.description,
            investment.barrierReached,
        );

        return custody;
    }

}
